import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useState, useEffect } from 'react';
import { useUuid, useUncontrolled, useDidUpdate } from '@mantine/hooks';
import { getDefaultZIndex, useMantineDefaultProps, extractSystemStyles } from '@mantine/styles';
import { ColorPicker } from '../ColorPicker/ColorPicker.js';
import useStyles from './ColorInput.styles.js';
import { isColorValid, parseColor } from '../ColorPicker/converters/parsers.js';
import { convertHsvaTo } from '../ColorPicker/converters/converters.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { Input } from '../Input/Input.js';
import { ColorSwatch } from '../ColorSwatch/ColorSwatch.js';
import { Popper } from '../Popper/Popper.js';
import { Paper } from '../Paper/Paper.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var SWATCH_SIZES = {
  xs: 16,
  sm: 18,
  md: 22,
  lg: 28,
  xl: 36
};
var ARROW_OFFSET = {
  xs: 12,
  sm: 15,
  md: 17,
  lg: 21,
  xl: 25
};
var defaultProps = {
  size: "sm",
  format: "hex",
  fixOnBlur: true,
  withPreview: true,
  swatchesPerRow: 10,
  withPicker: true,
  transition: "pop-top-left",
  dropdownZIndex: getDefaultZIndex("popover"),
  transitionDuration: 0,
  withinPortal: true
};
var ColorInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ColorInput", defaultProps, props),
      label = _a.label,
      description = _a.description,
      error = _a.error,
      required = _a.required,
      wrapperProps = _a.wrapperProps,
      size = _a.size,
      format = _a.format,
      onChange = _a.onChange,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      value = _a.value,
      defaultValue = _a.defaultValue,
      classNames = _a.classNames,
      styles = _a.styles,
      disallowInput = _a.disallowInput,
      fixOnBlur = _a.fixOnBlur,
      withPreview = _a.withPreview,
      swatchesPerRow = _a.swatchesPerRow,
      withPicker = _a.withPicker,
      icon = _a.icon,
      transition = _a.transition,
      id = _a.id,
      dropdownZIndex = _a.dropdownZIndex,
      transitionDuration = _a.transitionDuration,
      transitionTimingFunction = _a.transitionTimingFunction,
      withinPortal = _a.withinPortal,
      className = _a.className,
      style = _a.style,
      swatches = _a.swatches,
      sx = _a.sx,
      errorProps = _a.errorProps,
      labelProps = _a.labelProps,
      descriptionProps = _a.descriptionProps,
      others = __objRest(_a, ["label", "description", "error", "required", "wrapperProps", "size", "format", "onChange", "onFocus", "onBlur", "value", "defaultValue", "classNames", "styles", "disallowInput", "fixOnBlur", "withPreview", "swatchesPerRow", "withPicker", "icon", "transition", "id", "dropdownZIndex", "transitionDuration", "transitionTimingFunction", "withinPortal", "className", "style", "swatches", "sx", "errorProps", "labelProps", "descriptionProps"]);

  var _useStyles = useStyles({
    disallowInput: disallowInput
  }, {
    classNames: classNames,
    styles: styles,
    name: "ColorInput"
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _extractSystemStyles = extractSystemStyles(others),
      systemStyles = _extractSystemStyles.systemStyles,
      rest = _extractSystemStyles.rest;

  var uuid = useUuid(id);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dropdownOpened = _useState4[0],
      setDropdownOpened = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      lastValidValue = _useState6[0],
      setLastValidValue = _useState6[1];

  var _useUncontrolled = useUncontrolled({
    value: value,
    defaultValue: defaultValue,
    finalValue: "",
    rule: function rule(val) {
      return typeof val === "string";
    },
    onChange: onChange
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _value = _useUncontrolled2[0],
      setValue = _useUncontrolled2[1];

  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setDropdownOpened(true);
  };

  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    setDropdownOpened(false);
    fixOnBlur && setValue(lastValidValue);
  };

  useEffect(function () {
    if (isColorValid(_value) || _value.trim() === "") {
      setLastValidValue(_value);
    }
  }, [_value]);
  useDidUpdate(function () {
    if (isColorValid(_value)) {
      setValue(convertHsvaTo(format, parseColor(_value)));
    }
  }, [format]);
  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues(__spreadValues({
    label: label,
    description: description,
    error: error,
    required: required,
    classNames: classNames,
    styles: styles,
    size: size,
    id: uuid,
    className: className,
    style: style,
    __staticSelector: "ColorInput",
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React.createElement("div", {
    ref: setReferenceElement
  }, /* @__PURE__ */React.createElement(Input, __spreadProps(__spreadValues({}, rest), {
    ref: ref,
    __staticSelector: "ColorInput",
    id: uuid,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    spellCheck: false,
    size: size,
    value: _value,
    onChange: function onChange(event) {
      return setValue(event.currentTarget.value);
    },
    invalid: !!error,
    required: required,
    autoComplete: "nope",
    icon: icon || (withPreview ? /* @__PURE__ */React.createElement(ColorSwatch, {
      color: isColorValid(_value) ? _value : "#fff",
      size: theme.fn.size({
        size: size,
        sizes: SWATCH_SIZES
      })
    }) : null),
    readOnly: disallowInput,
    classNames: __spreadProps(__spreadValues({}, classNames), {
      input: cx(classes.input, classNames == null ? void 0 : classNames.input)
    }),
    styles: styles
  }))), /* @__PURE__ */React.createElement(Popper, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    transition: transition,
    mounted: dropdownOpened,
    position: "bottom",
    placement: "start",
    gutter: 5,
    arrowSize: 3,
    zIndex: dropdownZIndex,
    arrowStyle: {
      left: theme.fn.size({
        size: size,
        sizes: ARROW_OFFSET
      })
    },
    withinPortal: withinPortal
  }, /* @__PURE__ */React.createElement("div", {
    style: {
      pointerEvents: "all"
    }
  }, /* @__PURE__ */React.createElement(Paper, {
    shadow: "sm",
    p: size,
    className: classes.dropdownBody,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, /* @__PURE__ */React.createElement(ColorPicker, {
    __staticSelector: "ColorInput",
    value: _value,
    onChange: setValue,
    format: format,
    swatches: swatches,
    swatchesPerRow: swatchesPerRow,
    withPicker: withPicker,
    size: size,
    focusable: false,
    styles: styles,
    classNames: classNames
  })))));
});
ColorInput.displayName = "@mantine/core/ColorInput";
export { ColorInput };